export const PRODUCTS_PARAM = 'products'

export const SupportedProducts = ['embedded']
